<!--
 * @Author: CHY
 * @Date: 2022-12-13 14:13:24
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-05-24 18:02:51
 * @FilePath: \liancan-public-screen-school\src\App.vue
-->
<template>
    <div id="app" :class="{vertical: isVertical, dormitory: isDormitory}">
        <!-- 头部 -->
        <div class="header" v-if="!this.isDormitory">
            <header-page-vertical v-if="isVertical" ref="headerPageVertical" />
            <headerPage v-else ref="headerPage" />
        </div>
        <div class="view">
            <router-view />
        </div>
    </div>
</template>

<script>
    import headerPage from '@/components/headerPage';
    import headerPageVertical from '@/components/headerPageVertical';

    export default {
        name: 'App',
        components: {
            headerPage,
            headerPageVertical
        },
        provide() {
            return {}
        },
        data() {
            return {
                isDormitory: false,
                isVertical: false
            }
        },
        methods: {},
        mounted() {
            this.$nextTick(() => {
                this.isDormitory = this.$route.name === 'IndexDorm'
                this.isVertical = this.$route.name === 'IndexScroll'
            })
        },
        created() {}
    }
</script>

<style lang="scss">
    #app {
        width: 100vw;
        height: 100vh;
        font-family: Microsoft YaHei;
        background-size: 100% 100% !important;
        box-sizing: border-box;
        overflow: hidden;
        background-attachment: fixed;
        margin: 0px;
        background: url(./assets/images/page_bg_deep.png) no-repeat;

        &.vertical {
            background: url(./assets/images/page_bg_deep1.png) no-repeat;
        }

        &.dormitory {
            background: none;

            .view {
                height: 100%;
            }
        }
    }
</style>